module.exports = __webpack_public_path__ + "static/media/photo-2-1-sm.df5eb129.jpeg";